import { Injectable } from '@angular/core';
import { TextEncoder, TextDecoder } from 'text-encoding';

declare var jquery: any;
declare var $: any;

@Injectable()
export class UtilsService {

    private key: string = "X9v$G7!bK2pQ#rLm";

    constructor() { }

    /* Parse response using data id as array key */
    public parseResponse(data: any): any[] {
        let parseArray: any[] = [];
        for (let i = 0; i < data.details.length; i++) {
            parseArray[data.details[i].name] = data.details[i].value;
        }
        return parseArray;
    }

    /* Easy Javascript's localStorage */
    public localStorage(option: string, name: string, content: any = null): any {
        switch (option) {
            case "get":
                return localStorage.getItem(name);
            case "post":
                localStorage.setItem(name, content);
                break;
            case "delete":
                localStorage.removeItem(name);
                break;
        }
    }

    /* Parse a string to json */
    public toJson(string: string): any {
        return JSON.parse(string);
    }

    /* Parse a json to string */
    public toString(json: any): any {
        return JSON.stringify(json);
    }

    /* Get wait time in hh:mm:ss */
    public getWaitTime(sdate: string, edate: string = null, revert: boolean = false, withSeconds: boolean = true): any {
        if (typeof sdate == "undefined" || sdate == null) {
            if (withSeconds) {
                return "00:00:00";
            } else {
                return 0;
            }
        } else {
            sdate = (revert) ? this.parseDate(sdate, true) : this.parseDate(sdate);
            let startDate: any = new Date(sdate);

            let endDate: any
            if (edate == null || typeof edate == "undefined") {
                endDate = new Date();
            } else {
                edate = (revert) ? this.parseDate(edate, true) : this.parseDate(edate);
                endDate = new Date(edate);
            }

            let seconds: number = (endDate.getTime() - startDate.getTime()) / 1000;
            if (withSeconds) {
                return this.secondsToHms(seconds);
            } else {
                let result = Math.round(seconds / 60);
                if (result == null) {
                  return 0;
                } else {
                  return result;
                }

            }
        }
    }

    /* Parse date: dd/mm/yyyy hh:mm:ss to yyyy-mm-ddThh:mm:ss */
    private parseDate(date: string, revert: boolean = false): string {
        let cut: string[] = date.split(" ");
        let d: string = (revert) ? cut[1] : cut[0];
        let parseDate: string[] = d.split("-");
        let h: string = (revert) ? cut[0] : cut[1];
        let dateParsed: string = parseDate[0] + "-" + parseDate[1] + "-" + parseDate[2] + "T" + h;
        return dateParsed;
    }

    /* Convert seconds in hh:mm:ss */
    private secondsToHms(seconds: number): string {
        let h: any = Math.floor(seconds / 3600);
        if (h < 10) h = '0' + h;
        let m: any = Math.floor(seconds % 3600 / 60);
        if (m < 10) m = '0' + m;
        let s: any = Math.floor(seconds % 3600 % 60);
        if (s < 10) s = '0' + s;

        return h + ":" + m + ":" + s;
    }

    public initializeTooltip(): void {
        $(document).ready(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    }

    public convertToPlainText(input: string): string {
      if (!/<[^>]*>/g.test(input))
        return input;

      const withLineBreaks = input.replace(/<br\s*\/?>/g, '\n');
      const div = document.createElement("div");
      div.innerHTML = withLineBreaks;

      return div.innerText;
    }

    private stringToBytes(str: string) { return new TextEncoder().encode(str); }
    private bytesToString(bytes: Uint8Array): string { return new TextDecoder().decode(bytes); }

    private xorBytes(data: Uint8Array, key: string) {
      const keyBytes = this.stringToBytes(key);
      const out = new Uint8Array(data.length);
      for (let i = 0; i < data.length; i++) {
        out[i] = data[i] ^ keyBytes[i % keyBytes.length];
      }
      return out;
    }

    private base64FromBytes(bytes: Uint8Array): string {
      let binary = '';
      for (let i = 0; i < bytes.length; i++) {
          binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    }

    private bytesFromBase64(b64: string): Uint8Array {
      const binary = atob(b64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return bytes;
    }

    obfuscate(text: string): string {
      const inverted = text.split('').reverse().join('');
      const xored = this.xorBytes(this.stringToBytes(inverted), this.key);
      return this.base64FromBytes(xored);
    }

    deobfuscate(obfBase64: string): string {
      const bytes = this.bytesFromBase64(obfBase64);
      const xored = this.xorBytes(bytes, this.key);
      const inverted = this.bytesToString(xored);
      return inverted.split('').reverse().join('');
    }
}
